import { render, staticRenderFns } from "./PorcentagemMixComercializado.vue?vue&type=template&id=0a03d30f&scoped=true&"
import script from "./PorcentagemMixComercializado.vue?vue&type=script&lang=js&"
export * from "./PorcentagemMixComercializado.vue?vue&type=script&lang=js&"
import style0 from "./PorcentagemMixComercializado.vue?vue&type=style&index=0&id=0a03d30f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03d30f",
  null
  
)

export default component.exports